import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { ChartContext, ChartHeatmapDataItem } from 'src/app/shared/chart/chart.models';
import { VehicleFingerprintContext } from '../../vehicle-fingerprint.models';
import { buildDailyActivityData } from './daily-activity.utils';

@Component({
  selector: 'app-vehicle-fingerprint-daily-activity',
  templateUrl: './daily-activity.component.html',
  styleUrls: ['./daily-activity.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleFingerprintDailyActivityComponent implements OnChanges {
  @Input() context: VehicleFingerprintContext = { summary: null, unitId: '' };

  dayCount = 0;
  maxHours: number | null = null;
  days: ChartHeatmapDataItem[] = [];
  chartContext: ChartContext = {
    type: 'heatmap',
    title: 'نقشه حرارتی فعالیت روزانه',
    showTitle: false,
    data: [],
    colors: ['rgba(57,217,178,0.2)', 'rgba(57,217,178,1)'],
    theme: 'dark',
    unit: 'ساعت حرکت',
  };

  ngOnChanges(): void {
    this.days = buildDailyActivityData(this.context);
    this.dayCount = this.days.length;
    const values = this.days.filter(day => day.value !== null).map(day => day.value);
    this.maxHours = values.length ? Math.max(1, ...values) : null;
    this.chartContext = { ...this.chartContext, data: this.days };
  }
}
